const PbxxRecord = require('../pbxx_record')

module.exports = class LandingPageWidget extends PbxxRecord {
  static get class_name() {
    return 'LandingPageWidget'
  }
}
